import { createContext, Dispatch, Reducer, useContext, ReactNode, useReducer, useMemo } from 'react';
import { States, IAction } from '../interfaces/interfaces';
import { initialState as storeInitialState } from '../store/InitialState';

export interface IStateProviderProps {
    reducer: Reducer<States, IAction>;
    initialState: States;
    children: ReactNode;
}

export const StateContext = createContext<[States, Dispatch<IAction>]>([storeInitialState, () => ({})]);
export const StateProvider = ({ reducer, initialState, children }: IStateProviderProps) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return <StateContext.Provider value={useMemo(() => [state, dispatch], [state])}>{children}</StateContext.Provider>;
};
export const useStateValue = () => useContext(StateContext);
